import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(
        "div",
        {
          ref: "pageTitle",
          staticClass: "display-1 hd-page-title",
          attrs: { tabindex: "-1" },
        },
        [_vm._v(_vm._s(_vm.$t("create_attribute.title")))]
      ),
      _vm._t("default"),
      _c("actions-component", {
        attrs: { class_table: _vm.getClass },
        scopedSlots: _vm._u([
          {
            key: "description",
            fn: function () {
              return [
                _c(VBreadcrumbs, {
                  staticClass: "pa-0",
                  attrs: { items: _vm.getBreadcrumbs },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    staticClass: "btn-inca-secondary",
                    on: {
                      click: function ($event) {
                        return _vm.onDownloadLineamientos()
                      },
                    },
                  },
                  [
                    _c(VIcon, { attrs: { small: "", dense: "" } }, [
                      _vm._v("icon-download"),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("form_attrs_productize_usecase.download_rules")
                        ) +
                        " "
                    ),
                  ],
                  1
                ),
                _vm.canCreateAutomation
                  ? _c(
                      VBtn,
                      {
                        staticClass: "ml-1 btn-inca-secondary",
                        attrs: { dense: "", outlined: "" },
                        on: { click: _vm.openCreateDialog },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("create_attribute.new_automation")) +
                            " "
                        ),
                      ]
                    )
                  : _vm._e(),
                _c(
                  VBtn,
                  {
                    staticClass: "btn-inca-secondary",
                    attrs: { icon: "" },
                    on: { click: _vm.refreshClick },
                  },
                  [_c(VIcon, [_vm._v("mdi-refresh")])],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        VRow,
        {
          class: {
            "flex-filter": _vm.size_screen == "sm" || _vm.size_screen == "xs",
          },
        },
        [
          _c(
            "div",
            { class: _vm.getClassTable },
            [
              _c(
                VCard,
                [
                  _c(VDataTable, {
                    staticClass: "text-center table-inca",
                    attrs: {
                      responsive: "",
                      hover: "",
                      items: _vm.items,
                      headers: _vm.headers,
                      loading: _vm.isLoading,
                      "hide-default-footer": "",
                      "items-per-page": _vm.pagination.limit,
                      page: _vm.pagination.current,
                      "sort-by": _vm.sortBy,
                      "sort-desc": _vm.sortDesc,
                    },
                    on: {
                      "update:page": function ($event) {
                        return _vm.$set(_vm.pagination, "current", $event)
                      },
                      "update:sortBy": function ($event) {
                        _vm.sortBy = $event
                      },
                      "update:sort-by": function ($event) {
                        _vm.sortBy = $event
                      },
                      "update:sortDesc": function ($event) {
                        _vm.sortDesc = $event
                      },
                      "update:sort-desc": function ($event) {
                        _vm.sortDesc = $event
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.fecha_creacion",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatDateTimeLima(item.fecha_creacion)
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                      {
                        key: "item.nombre_tabla",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _vm._v(
                              " " + _vm._s(item.nombre_tabla || "-") + " "
                            ),
                          ]
                        },
                      },
                      {
                        key: "item.owner_name",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _c("span", [
                              _vm._v(_vm._s(item.owner_name || "-")),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "item.company_name",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _vm._v(
                              " " + _vm._s(item.company_name || "-") + " "
                            ),
                          ]
                        },
                      },
                      {
                        key: "item.estado",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _c(
                              "div",
                              { staticClass: "status-cell" },
                              [
                                _c(
                                  VChip,
                                  {
                                    attrs: {
                                      small: "",
                                      "text-color": _vm.getStatus(item.estado)
                                        .textColor,
                                      color: _vm.getStatus(item.estado).color,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.getStatus(item.estado).text
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _vm.hasActiveBatch(item)
                                  ? _c(
                                      VChip,
                                      {
                                        staticClass: "status-cell__batch",
                                        attrs: {
                                          "x-small": "",
                                          outlined: "",
                                          color: "info",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openActivityTimeline(
                                              item,
                                              { focusActive: true }
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          VIcon,
                                          {
                                            attrs: { left: "", "x-small": "" },
                                          },
                                          [_vm._v("mdi-progress-clock")]
                                        ),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.batchProgressLabel(item)
                                            ) +
                                            " "
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "item.action",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _c(
                              VMenu,
                              {
                                attrs: { "offset-y": "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function (ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            VBtn,
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  attrs: {
                                                    icon: "",
                                                    "aria-label": _vm.$t(
                                                      "create_attribute.actions.row_menu",
                                                      {
                                                        name:
                                                          item.nombre_tabla ||
                                                          item.automate_id,
                                                      }
                                                    ),
                                                    "data-row-actions":
                                                      item.automate_id,
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c(VIcon, [
                                                _vm._v("mdi-dots-vertical"),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c(
                                  VList,
                                  [
                                    _c(
                                      VListItem,
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.openDetailDialog(item)
                                          },
                                        },
                                      },
                                      [
                                        _c(VListItemTitle, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "create_attribute.actions.view_detail"
                                              )
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VListItem,
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.openActivityTimeline(
                                              item
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(VListItemTitle, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "create_attribute.actions.view_activity"
                                              )
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VListItem,
                                      {
                                        attrs: {
                                          disabled:
                                            _vm.isInactiveStatus(item.estado) ||
                                            _vm.isPendingReviewStatus(
                                              item.estado
                                            ) ||
                                            _vm.isErrorStatus(item.estado),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openLoadMonthsDialog(
                                              item
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(VListItemTitle, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "create_attribute.actions.load_months"
                                              )
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    false
                                      ? _c(
                                          VListItem,
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.openEditScriptDialog(
                                                  item
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(VListItemTitle, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "create_attribute.actions.edit_script"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      VListItem,
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.deactivateAutomation(
                                              item
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(VListItemTitle, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "create_attribute.actions.deactivate"
                                              )
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VListItem,
                                      {
                                        attrs: { disabled: !item.nombre_tabla },
                                        on: {
                                          click: function ($event) {
                                            return _vm.goToMetadata(item)
                                          },
                                        },
                                      },
                                      [
                                        _c(VListItemTitle, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "create_attribute.actions.update_metadata"
                                              )
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm.isIntercorpAdmin
                                      ? _c(
                                          VListItem,
                                          {
                                            attrs: {
                                              disabled:
                                                !_vm.allowedStatusTargets(
                                                  item.estado
                                                ).length,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.openChangeStatusDialog(
                                                  item
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(VListItemTitle, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "create_attribute.actions.change_status"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.canHardDelete
                                      ? [
                                          _c(VDivider, {
                                            staticClass: "my-1",
                                          }),
                                          _c(
                                            VListItem,
                                            {
                                              staticClass: "hd-menu-danger",
                                              attrs: {
                                                disabled:
                                                  Number(item.estado) === 20,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openHardDeleteDialog(
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                VListItemIcon,
                                                [
                                                  _c(
                                                    VIcon,
                                                    {
                                                      attrs: {
                                                        small: "",
                                                        color: "#a8144a",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "mdi-delete-forever-outline"
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(VListItemTitle, [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "create_attribute.actions.hard_delete"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("pagination-vue", {
                    attrs: { pagination: _vm.pagination },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.filter_enabled
            ? _c(
                "div",
                {
                  staticClass: "col-md-3 col-sm-12 mb-3",
                  class: {
                    "pl-0": _vm.size_screen == "md" || _vm.size_screen == "lg",
                  },
                },
                [
                  _c(
                    VCard,
                    { staticClass: "filters-inca" },
                    [
                      _c(
                        VCardTitle,
                        {
                          staticClass: "pointer",
                          on: {
                            click: function ($event) {
                              _vm.collapse_filter = !_vm.collapse_filter
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("titles.search_filters")) + " "
                          ),
                        ]
                      ),
                      _c(
                        VCardText,
                        { staticClass: "pa-2 pt-0" },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "12" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      label: _vm.$t(
                                        "create_attribute.filters.use_case"
                                      ),
                                      outlined: "",
                                      dense: "",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.filters.use_case,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "use_case", $$v)
                                      },
                                      expression: "filters.use_case",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "12" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      label: _vm.$t(
                                        "create_attribute.filters.table_name"
                                      ),
                                      outlined: "",
                                      dense: "",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.filters.nombre_tabla,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.filters,
                                          "nombre_tabla",
                                          $$v
                                        )
                                      },
                                      expression: "filters.nombre_tabla",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "12" } },
                                [
                                  _c(VSelect, {
                                    attrs: {
                                      label: _vm.$t(
                                        "create_attribute.filters.status"
                                      ),
                                      outlined: "",
                                      dense: "",
                                      items: _vm.statusOptions,
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.filters.estado,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "estado", $$v)
                                      },
                                      expression: "filters.estado",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    VMenu,
                                    {
                                      attrs: {
                                        "close-on-content-click": false,
                                        transition: "scale-transition",
                                        "offset-y": "",
                                        "min-width": "auto",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  VTextField,
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        attrs: {
                                                          label: _vm.$t(
                                                            "create_attribute.filters.date"
                                                          ),
                                                          outlined: "",
                                                          dense: "",
                                                          "prepend-icon":
                                                            "mdi-calendar",
                                                          readonly: "",
                                                          clearable: "",
                                                        },
                                                        on: {
                                                          "click:clear":
                                                            function ($event) {
                                                              _vm.filters.fecha =
                                                                ""
                                                            },
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.filters.fecha,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.filters,
                                                              "fecha",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "filters.fecha",
                                                        },
                                                      },
                                                      "v-text-field",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  )
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        1171151453
                                      ),
                                      model: {
                                        value: _vm.dateMenu,
                                        callback: function ($$v) {
                                          _vm.dateMenu = $$v
                                        },
                                        expression: "dateMenu",
                                      },
                                    },
                                    [
                                      _c(VDatePicker, {
                                        attrs: {
                                          "no-title": "",
                                          scrollable: "",
                                          locale: "es",
                                        },
                                        on: {
                                          input: function ($event) {
                                            _vm.dateMenu = false
                                          },
                                        },
                                        model: {
                                          value: _vm.filters.fecha,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.filters, "fecha", $$v)
                                          },
                                          expression: "filters.fecha",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                {
                                  staticClass: "text-right",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c(
                                    VBtn,
                                    {
                                      staticClass: "default mr-1",
                                      attrs: { outlined: "" },
                                      on: { click: _vm.onLimpiar },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("btns.clean")) + " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    VBtn,
                                    {
                                      staticClass: "primary",
                                      on: { click: _vm.onBuscar },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("btns.search")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _c("dialogs-component", {
        ref: _vm.DIALOG_CREATE,
        attrs: {
          title: _vm.$t("create_attribute.dialogs.new_automation"),
          "show-buttons": true,
          "show-cancel-button": false,
          width: 900,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c("create-attribute-form", {
                  ref: "createForm",
                  attrs: { "existing-table-names": _vm.existingTableNames },
                  on: {
                    "on-close": _vm.onCloseCreate,
                    saved: _vm.onSaved,
                    "pending-review": _vm.onPendingReview,
                    "step-changed": _vm.onFormStepChanged,
                    "validity-changed": _vm.onFormValidityChanged,
                    "sending-changed": _vm.onFormSendingChanged,
                    "error-with-side-effects": _vm.onFormErrorWithSideEffects,
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsLeft",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    staticClass: "btn-inca-secondary",
                    on: {
                      click: function ($event) {
                        return _vm.onDownloadLineamientos()
                      },
                    },
                  },
                  [
                    _c(VIcon, { attrs: { small: "", dense: "" } }, [
                      _vm._v("icon-download"),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("form_attrs_productize_usecase.download_rules")
                        ) +
                        " "
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsRight",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    attrs: {
                      color: "primary",
                      disabled: !_vm.createFormValid || _vm.formSending,
                      loading: _vm.formSending,
                    },
                    on: { click: _vm.saveCreation },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("btns.save")) + " ")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialogs-component", {
        ref: _vm.DIALOG_DETAIL,
        attrs: {
          title: _vm.$t("create_attribute.dialogs.detail"),
          "show-buttons": false,
          width: 1000,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _vm.selectedItem.automate_id
                  ? _c("create-attribute-detail", {
                      key: _vm.selectedItem.automate_id,
                      attrs: { item: _vm.selectedItem },
                    })
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialogs-component", {
        ref: _vm.DIALOG_LOAD_MONTHS,
        attrs: {
          title: _vm.$t("create_attribute.dialogs.load_months"),
          "show-buttons": true,
          "show-cancel-button": true,
          width: 700,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  VRow,
                  { attrs: { dense: "" } },
                  [
                    _c(VCol, { attrs: { cols: "12" } }, [
                      _c("p", { staticClass: "mb-1 text-body-2" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("create_attribute.load_months.subtitle")
                            ) +
                            " "
                        ),
                      ]),
                      _c(
                        "p",
                        {
                          staticClass:
                            "mb-3 text-caption grey--text text--darken-1",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "create_attribute.load_months.background_hint"
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]),
                    _c(
                      VCol,
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        _c(VSelect, {
                          attrs: {
                            label: _vm.$t("create_attribute.form.month"),
                            outlined: "",
                            dense: "",
                            clearable: "",
                            "hide-details": "auto",
                            items: _vm.months,
                            "item-text": "name",
                            "item-value": "value",
                          },
                          model: {
                            value: _vm.selectedLoadMonth,
                            callback: function ($$v) {
                              _vm.selectedLoadMonth = $$v
                            },
                            expression: "selectedLoadMonth",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      VCol,
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        _c(VSelect, {
                          attrs: {
                            label: _vm.$t("create_attribute.form.year"),
                            outlined: "",
                            dense: "",
                            clearable: "",
                            "hide-details": "auto",
                            items: _vm.loadMonthYears,
                            "item-text": "name",
                            "item-value": "value",
                          },
                          model: {
                            value: _vm.selectedLoadYear,
                            callback: function ($$v) {
                              _vm.selectedLoadYear = $$v
                            },
                            expression: "selectedLoadYear",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      VCol,
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        _c(
                          VBtn,
                          {
                            attrs: {
                              block: "",
                              color: "primary",
                              disabled: !_vm.canAddLoadMonthPeriod,
                            },
                            on: { click: _vm.addLoadMonthPeriod },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("create_attribute.form.add_period")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      VCol,
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          VChipGroup,
                          { attrs: { column: "" } },
                          _vm._l(_vm.selectedPeriods, function (period, index) {
                            return _c(
                              VChip,
                              {
                                key: period,
                                staticClass: "caption",
                                attrs: { color: "primary", close: "" },
                                on: {
                                  "click:close": function ($event) {
                                    return _vm.removeLoadMonthPeriod(index)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.formatPeriodLabel(period)) +
                                    " "
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                        _c(
                          "p",
                          {
                            staticClass:
                              "text-caption grey--text text--darken-1 mb-0",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "create_attribute.load_months.max_periods_hint",
                                    { max: _vm.maxLoadMonthPeriods }
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm.selectedPeriods.length > 0
                      ? _c(
                          VCol,
                          { attrs: { cols: "12" } },
                          [
                            _c(
                              VAlert,
                              {
                                staticClass: "mb-0",
                                attrs: {
                                  dense: "",
                                  outlined: "",
                                  type: "info",
                                  icon: "mdi-calendar-check",
                                },
                              },
                              [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(_vm.selectedPeriods.length) +
                                      " / " +
                                      _vm._s(_vm.maxLoadMonthPeriods)
                                  ),
                                ]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "create_attribute.load_months.summary_prefix"
                                      )
                                    ) +
                                    ": " +
                                    _vm._s(_vm.selectedPeriodsSummary) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsRight",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    attrs: {
                      color: "primary",
                      disabled:
                        !_vm.canConfirmLoadMonths || _vm.loadMonthsSending,
                      loading: _vm.loadMonthsSending,
                    },
                    on: { click: _vm.confirmLoadMonths },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("btns.confirm")) + " ")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialog-confirmation-component", {
        ref: "dialogDeactivate",
        attrs: {
          title: _vm.$t("create_attribute.dialogs.deactivate_title"),
          text: _vm.deactivateDialogText,
          si_text: _vm.$t("create_attribute.dialogs.deactivate_yes"),
          no_text: _vm.$t("create_attribute.dialogs.deactivate_no"),
          width: 480,
        },
        on: { onConfirm: _vm.onConfirmDeactivate },
      }),
      _c("dialog-confirmation-component", {
        ref: "dialogCreateSuccess",
        attrs: {
          title: _vm.$t("create_attribute.dialogs.created_title"),
          text: _vm.$t("create_attribute.dialogs.created_activity_text"),
          si_text: _vm.$t("create_attribute.dialogs.created_activity_yes"),
          no_text: _vm.$t("create_attribute.dialogs.created_activity_no"),
        },
        on: { onConfirm: _vm.onConfirmCreateSuccess },
      }),
      _c("dialog-confirmation-component", {
        ref: "dialogLoadMonthsSuccess",
        attrs: {
          title: _vm.$t("create_attribute.dialogs.load_months_started_title"),
          text: _vm.$t("create_attribute.dialogs.load_months_activity_text"),
          si_text: _vm.$t("create_attribute.dialogs.created_activity_yes"),
          no_text: _vm.$t("create_attribute.dialogs.created_activity_no"),
        },
        on: { onConfirm: _vm.onConfirmLoadMonthsSuccess },
      }),
      _c("activity-timeline-dialog", { ref: "activityTimelineDialog" }),
      _c("edit-script-dialog", {
        ref: "editScriptDialog",
        on: { updated: _vm.onScriptUpdated },
      }),
      _c("dialogs-component", {
        ref: _vm.DIALOG_HARD_DELETE,
        attrs: {
          width: 720,
          custom_title: true,
          "show-cancel-button": false,
          role: "alertdialog",
          "aria-labelledby": "hd-title hd-name",
          "aria-describedby": "hd-desc",
          "initial-focus": "[data-hd-cancel]",
          "title-class": "dialog-title--plain",
          "esc-to-close": !_vm.hardDeleteSending,
          closable: !_vm.hardDeleteSending,
          "close-label": _vm.$t("create_attribute.hard_delete.close_label"),
        },
        on: { onCloseClick: _vm.onHardDeleteClosed },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _c("div", { staticClass: "hd-head" }, [
                  _c(
                    "span",
                    {
                      staticClass: "hd-head__badge",
                      attrs: { "aria-hidden": "true" },
                    },
                    [
                      _c(VIcon, { attrs: { color: "#a8144a" } }, [
                        _vm._v("mdi-delete-forever-outline"),
                      ]),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "hd-head__text" }, [
                    _c(
                      "h2",
                      { staticClass: "hd-title", attrs: { id: "hd-title" } },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "create_attribute.hard_delete.dialog_heading"
                            )
                          )
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "hd-name", attrs: { id: "hd-name" } },
                      [_vm._v(_vm._s(_vm.hardDeleteTargetName))]
                    ),
                    _c("div", { staticClass: "hd-meta" }, [
                      _vm._v(_vm._s(_vm.hardDeleteMetaText)),
                    ]),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c("div", { staticClass: "hd-body" }, [
                  _c(
                    "p",
                    { staticClass: "hd-desc", attrs: { id: "hd-desc" } },
                    [
                      _vm._v(" " + _vm._s(_vm.hardDeleteDescription) + " "),
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("create_attribute.hard_delete.cannot_undo")
                          )
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "hd-sr-only",
                      attrs: { role: "status", "aria-live": "polite" },
                    },
                    [_vm._v(_vm._s(_vm.hardDeleteLiveMessage))]
                  ),
                  _vm.hardDeleteOutcome
                    ? _c(
                        "div",
                        {
                          class: [
                            "hd-alert",
                            "hd-alert--" + _vm.hardDeleteOutcome.tone,
                          ],
                          attrs: { role: "alert" },
                        },
                        [
                          _c(
                            VIcon,
                            { attrs: { small: "", "aria-hidden": "true" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.hardDeleteOutcome.tone === "warn"
                                    ? "mdi-alert-outline"
                                    : "mdi-alert-circle-outline"
                                )
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            [
                              _c("strong", { staticClass: "hd-alert__title" }, [
                                _vm._v(_vm._s(_vm.hardDeleteOutcome.title)),
                              ]),
                              _vm.hardDeleteOutcome.text
                                ? _c("p", [
                                    _vm._v(_vm._s(_vm.hardDeleteOutcome.text)),
                                  ])
                                : _vm._e(),
                              _vm.hardDeleteOutcome.action
                                ? _c("p", [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "create_attribute.hard_delete.what_to_do"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.hardDeleteOutcome.action) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm.hardDeleteOutcome.kind === "in_progress"
                                ? _c(
                                    VBtn,
                                    {
                                      staticClass: "btn-inca-secondary mt-2",
                                      attrs: { small: "", depressed: "" },
                                      on: {
                                        click: _vm.refreshDeletionInProgress,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "create_attribute.hard_delete.outcome_in_progress_btn"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.hardDeleteStepRows.length
                    ? _c(
                        "section",
                        { attrs: { "aria-labelledby": "hd-steps-title" } },
                        [
                          _c(
                            "h3",
                            {
                              staticClass: "hd-section-title",
                              attrs: { id: "hd-steps-title" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.hardDeleteSending ||
                                      _vm.hardDeleteProgress
                                      ? _vm.$t(
                                          "create_attribute.hard_delete.progress_title"
                                        )
                                      : _vm.$t(
                                          "create_attribute.hard_delete.checklist_title"
                                        )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _vm.hardDeleteRetrying
                            ? _c("p", { staticClass: "hd-hint" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "create_attribute.hard_delete.checklist_hint"
                                    )
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _c(
                            "ul",
                            { staticClass: "hd-steps" },
                            _vm._l(_vm.hardDeleteStepRows, function (s) {
                              return _c(
                                "li",
                                {
                                  key: s.step,
                                  class: ["hd-step", "hd-step--" + s.state],
                                },
                                [
                                  _c(
                                    VIcon,
                                    {
                                      attrs: {
                                        small: "",
                                        "aria-hidden": "true",
                                      },
                                    },
                                    [_vm._v(_vm._s(s.icon))]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "hd-step__main" },
                                    [
                                      _c("div", [_vm._v(_vm._s(s.label))]),
                                      s.detail
                                        ? _c(
                                            "div",
                                            { staticClass: "hd-step__detail" },
                                            [_vm._v(_vm._s(s.detail))]
                                          )
                                        : _vm._e(),
                                      s.canSkip
                                        ? _c(VCheckbox, {
                                            staticClass: "hd-skip",
                                            attrs: {
                                              value: s.step,
                                              label: _vm.$t(
                                                "create_attribute.hard_delete.skip_label"
                                              ),
                                              dense: "",
                                              "hide-details": "",
                                            },
                                            model: {
                                              value: _vm.hardDeleteSkipSteps,
                                              callback: function ($$v) {
                                                _vm.hardDeleteSkipSteps = $$v
                                              },
                                              expression: "hardDeleteSkipSteps",
                                            },
                                          })
                                        : s.skipBlocked
                                        ? _c(
                                            "div",
                                            { staticClass: "hd-step__detail" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "create_attribute.hard_delete.skip_blocked"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "hd-step__state" },
                                    [_vm._v(_vm._s(s.stateLabel))]
                                  ),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                          _vm.hardDeleteHiddenStepCount
                            ? _c("p", { staticClass: "hd-hint mt-1" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$tc(
                                        "create_attribute.hard_delete.hidden_steps",
                                        _vm.hardDeleteHiddenStepCount,
                                        { n: _vm.hardDeleteHiddenStepCount }
                                      )
                                    ) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                          _vm.hardDeleteSkipSteps.length
                            ? _c(
                                "div",
                                { staticClass: "hd-alert hd-alert--warn mt-2" },
                                [
                                  _c(
                                    VIcon,
                                    {
                                      attrs: {
                                        small: "",
                                        "aria-hidden": "true",
                                      },
                                    },
                                    [_vm._v("mdi-alert-outline")]
                                  ),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "create_attribute.hard_delete.skip_warning"
                                        )
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                  !_vm.hardDeleteSending && !_vm.hardDeleteRetrying
                    ? _c(
                        "section",
                        { attrs: { "aria-labelledby": "hd-impact-title" } },
                        [
                          _c(
                            "h3",
                            {
                              staticClass: "hd-section-title",
                              attrs: { id: "hd-impact-title" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "create_attribute.hard_delete.impact_title"
                                  )
                                )
                              ),
                            ]
                          ),
                          _vm.hardDeletePreviewLoading
                            ? _c(
                                "div",
                                { attrs: { "aria-busy": "true" } },
                                [
                                  _c(VSkeletonLoader, {
                                    attrs: {
                                      type: "list-item-two-line, list-item-two-line",
                                    },
                                  }),
                                  _c("span", { staticClass: "hd-sr-only" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "create_attribute.hard_delete.preview_loading"
                                        )
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm.hardDeletePreviewError
                            ? [
                                _c(
                                  "div",
                                  { staticClass: "hd-alert hd-alert--error" },
                                  [
                                    _c(
                                      VIcon,
                                      {
                                        attrs: {
                                          small: "",
                                          "aria-hidden": "true",
                                        },
                                      },
                                      [_vm._v("mdi-alert-circle-outline")]
                                    ),
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "strong",
                                          { staticClass: "hd-alert__title" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "create_attribute.hard_delete.preview_error_title"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "create_attribute.hard_delete.preview_error_text"
                                              )
                                            )
                                          ),
                                        ]),
                                        _c(
                                          VBtn,
                                          {
                                            staticClass:
                                              "btn-inca-secondary mt-2",
                                            attrs: { small: "", depressed: "" },
                                            on: {
                                              click: _vm.retryHardDeletePreview,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "create_attribute.hard_delete.preview_retry"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.hardDeletePreviewFails >= 2
                                  ? _c(
                                      "div",
                                      { staticClass: "hd-check mt-2" },
                                      [
                                        _c(VCheckbox, {
                                          staticClass: "ma-0 pa-0",
                                          attrs: {
                                            label: _vm.$t(
                                              "create_attribute.hard_delete.preview_ack"
                                            ),
                                            dense: "",
                                            "hide-details": "",
                                          },
                                          model: {
                                            value: _vm.hardDeletePreviewAck,
                                            callback: function ($$v) {
                                              _vm.hardDeletePreviewAck = $$v
                                            },
                                            expression: "hardDeletePreviewAck",
                                          },
                                        }),
                                        _c("p", { staticClass: "hd-hint" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "create_attribute.hard_delete.preview_ack_hint"
                                              )
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            : _c(
                                "ul",
                                { staticClass: "hd-impact" },
                                _vm._l(
                                  _vm.hardDeleteImpactRows,
                                  function (row) {
                                    return _c(
                                      "li",
                                      {
                                        key: row.key,
                                        class: [
                                          "hd-imp",
                                          "hd-imp--" + row.tone,
                                        ],
                                      },
                                      [
                                        _c(
                                          VIcon,
                                          {
                                            attrs: {
                                              small: "",
                                              "aria-hidden": "true",
                                            },
                                          },
                                          [_vm._v(_vm._s(row.icon))]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "hd-imp__main" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "hd-imp__tag" },
                                              [_vm._v(_vm._s(row.tag))]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "hd-imp__title" },
                                              [_vm._v(_vm._s(row.title))]
                                            ),
                                            row.text
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticClass: "hd-imp__text",
                                                  },
                                                  [_vm._v(_vm._s(row.text))]
                                                )
                                              : _vm._e(),
                                            row.items && row.items.length
                                              ? [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "hd-disclosure",
                                                      attrs: {
                                                        type: "button",
                                                        "aria-expanded": String(
                                                          _vm.isHardDeleteDetailOpen(
                                                            row.key
                                                          )
                                                        ),
                                                        "aria-controls":
                                                          "hd-detail-" +
                                                          row.key,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.toggleHardDeleteDetail(
                                                            row.key
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        VIcon,
                                                        {
                                                          attrs: {
                                                            "x-small": "",
                                                            "aria-hidden":
                                                              "true",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.isHardDeleteDetailOpen(
                                                                row.key
                                                              )
                                                                ? "mdi-chevron-down"
                                                                : "mdi-chevron-right"
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            row.toggleLabel
                                                          ) +
                                                          " "
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "ul",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            _vm.isHardDeleteDetailOpen(
                                                              row.key
                                                            ),
                                                          expression:
                                                            "isHardDeleteDetailOpen(row.key)",
                                                        },
                                                      ],
                                                      staticClass: "hd-detail",
                                                      attrs: {
                                                        id:
                                                          "hd-detail-" +
                                                          row.key,
                                                      },
                                                    },
                                                    _vm._l(
                                                      row.items,
                                                      function (it) {
                                                        return _c(
                                                          "li",
                                                          {
                                                            key: it.key,
                                                            staticClass:
                                                              "hd-res",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "hd-res__label",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    it.label
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            it.ref
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    class: [
                                                                      "hd-res__ref",
                                                                      {
                                                                        "hd-mono":
                                                                          it.mono,
                                                                      },
                                                                    ],
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        it.ref
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            it.metrics
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "hd-res__num",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        it.metrics
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              : _vm._e(),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.hardDeleteShowAlternative
                    ? _c(
                        "div",
                        { staticClass: "hd-alt" },
                        [
                          _c(
                            VIcon,
                            { attrs: { small: "", "aria-hidden": "true" } },
                            [_vm._v("mdi-information-outline")]
                          ),
                          _c(
                            "div",
                            [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "create_attribute.hard_delete.alternative_title"
                                    )
                                  )
                                ),
                              ]),
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "create_attribute.hard_delete.alternative_text"
                                    )
                                  )
                                ),
                              ]),
                              _c(
                                VBtn,
                                {
                                  staticClass: "hd-alt__btn",
                                  attrs: {
                                    text: "",
                                    small: "",
                                    color: "primary",
                                  },
                                  on: { click: _vm.deactivateInsteadOfDelete },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "create_attribute.hard_delete.alternative_btn"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.hardDeleteShowConfirm
                    ? _c(
                        "section",
                        {
                          staticClass: "hd-confirm",
                          attrs: { "aria-labelledby": "hd-confirm-title" },
                        },
                        [
                          _c(
                            "h3",
                            {
                              staticClass: "hd-section-title",
                              attrs: { id: "hd-confirm-title" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "create_attribute.hard_delete.confirm_title"
                                  )
                                )
                              ),
                            ]
                          ),
                          _c(VTextarea, {
                            attrs: {
                              id: "hd-reason",
                              label: _vm.$t(
                                "create_attribute.hard_delete.reason_label"
                              ),
                              "error-messages": _vm.hardDeleteReasonError
                                ? [_vm.hardDeleteReasonError]
                                : [],
                              "aria-describedby": "hd-reason-hint",
                              maxlength: "500",
                              rows: "3",
                              outlined: "",
                              dense: "",
                              "hide-details": "auto",
                            },
                            on: {
                              blur: function ($event) {
                                _vm.hardDeleteTouched.reason = true
                              },
                            },
                            model: {
                              value: _vm.hardDeleteReason,
                              callback: function ($$v) {
                                _vm.hardDeleteReason = $$v
                              },
                              expression: "hardDeleteReason",
                            },
                          }),
                          _c(
                            "div",
                            {
                              staticClass: "hd-hint-row",
                              attrs: { id: "hd-reason-hint" },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "create_attribute.hard_delete.reason_hint"
                                    )
                                  )
                                ),
                              ]),
                              _c("span", { attrs: { "aria-hidden": "true" } }, [
                                _vm._v(
                                  _vm._s(_vm.hardDeleteReasonLength) + " / 500"
                                ),
                              ]),
                            ]
                          ),
                          !_vm.hardDeleteRetrying &&
                          _vm.hardDeleteLevel >= 2 &&
                          _vm.hardDeleteTargetName
                            ? [
                                _c("i18n", {
                                  staticClass: "hd-name-instruction",
                                  attrs: {
                                    id: "hd-name-instruction",
                                    path: "create_attribute.hard_delete.name_instruction",
                                    tag: "p",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "name",
                                        fn: function () {
                                          return [
                                            _c(
                                              "code",
                                              { staticClass: "hd-code" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.hardDeleteTargetName
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    1368594999
                                  ),
                                }),
                                _c(VTextField, {
                                  staticClass: "hd-input--mono",
                                  attrs: {
                                    id: "hd-name-input",
                                    label: _vm.$t(
                                      "create_attribute.hard_delete.name_label"
                                    ),
                                    "error-messages": _vm.hardDeleteNameMismatch
                                      ? [
                                          _vm.$t(
                                            "create_attribute.hard_delete.name_mismatch"
                                          ),
                                        ]
                                      : [],
                                    "aria-describedby": "hd-name-instruction",
                                    autocomplete: "off",
                                    spellcheck: "false",
                                    autocapitalize: "off",
                                    outlined: "",
                                    dense: "",
                                    "hide-details": "auto",
                                  },
                                  on: {
                                    blur: function ($event) {
                                      _vm.hardDeleteTouched.name = true
                                    },
                                  },
                                  model: {
                                    value: _vm.hardDeleteConfirmName,
                                    callback: function ($$v) {
                                      _vm.hardDeleteConfirmName = $$v
                                    },
                                    expression: "hardDeleteConfirmName",
                                  },
                                }),
                              ]
                            : _vm._e(),
                          !_vm.hardDeleteRetrying && _vm.hardDeleteNeedsForce
                            ? _c(
                                "div",
                                { staticClass: "hd-check" },
                                [
                                  _c(VCheckbox, {
                                    staticClass: "ma-0 pa-0",
                                    attrs: {
                                      label: _vm.$t(
                                        "create_attribute.hard_delete.force_label"
                                      ),
                                      dense: "",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value: _vm.hardDeleteForce,
                                      callback: function ($$v) {
                                        _vm.hardDeleteForce = $$v
                                      },
                                      expression: "hardDeleteForce",
                                    },
                                  }),
                                  _c("p", { staticClass: "hd-hint" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "create_attribute.hard_delete.force_hint"
                                        )
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.hardDeleteRetrying && _vm.hardDeleteLevel === 3
                            ? _c(
                                "div",
                                { staticClass: "hd-check" },
                                [
                                  _c(VCheckbox, {
                                    staticClass: "ma-0 pa-0",
                                    attrs: {
                                      label: _vm.hardDeleteConsumers.error
                                        ? _vm.$t(
                                            "create_attribute.hard_delete.ack_consumers_unknown"
                                          )
                                        : _vm.$tc(
                                            "create_attribute.hard_delete.ack_consumers",
                                            _vm.hardDeleteConsumers.count,
                                            { n: _vm.hardDeleteConsumers.count }
                                          ),
                                      dense: "",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value: _vm.hardDeleteAckConsumers,
                                      callback: function ($$v) {
                                        _vm.hardDeleteAckConsumers = $$v
                                      },
                                      expression: "hardDeleteAckConsumers",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsLeft",
            fn: function () {
              return [
                _c(
                  "p",
                  { staticClass: "hd-missing", attrs: { id: "hd-missing" } },
                  [_vm._v(_vm._s(_vm.hardDeleteFooterText))]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsRight",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    staticClass: "default",
                    attrs: {
                      "data-hd-cancel": "",
                      text: "",
                      outlined: "",
                      disabled: _vm.hardDeleteSending,
                    },
                    on: { click: _vm.closeHardDeleteDialog },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("btns.cancel")) + " ")]
                ),
                _c(
                  VBtn,
                  {
                    class:
                      _vm.canConfirmHardDelete || _vm.hardDeleteSending
                        ? "btn-inca-danger"
                        : "hd-btn-off",
                    attrs: {
                      depressed: "",
                      loading: _vm.hardDeleteSending,
                      "aria-disabled": String(
                        !_vm.canConfirmHardDelete || _vm.hardDeleteSending
                      ),
                      "aria-describedby": "hd-missing",
                    },
                    on: { click: _vm.confirmHardDelete },
                    scopedSlots: _vm._u([
                      {
                        key: "loader",
                        fn: function () {
                          return [
                            _c(VProgressCircular, {
                              staticClass: "mr-2",
                              attrs: {
                                indeterminate: "",
                                size: "16",
                                width: "2",
                              },
                            }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "create_attribute.hard_delete.sending_btn"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.hardDeleteRetrying
                            ? _vm.$t("create_attribute.hard_delete.retry_btn")
                            : _vm.$t("create_attribute.hard_delete.confirm_btn")
                        ) +
                        " "
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialogs-component", {
        ref: _vm.DIALOG_CHANGE_STATUS,
        attrs: {
          title: _vm.$t("create_attribute.dialogs.change_status_title"),
          "show-buttons": true,
          "show-cancel-button": true,
          width: 560,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  VAlert,
                  {
                    staticClass: "mb-3",
                    attrs: { dense: "", outlined: "", type: "info" },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("create_attribute.change_status.warning")
                        ) +
                        " "
                    ),
                  ]
                ),
                _c("p", { staticClass: "mb-2" }, [
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("create_attribute.change_status.target_label")
                      ) + ":"
                    ),
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        (_vm.changeStatusTarget &&
                          _vm.changeStatusTarget.nombre_tabla) ||
                          "-"
                      ) +
                      " "
                  ),
                  _c(
                    "span",
                    {
                      staticClass:
                        "text-caption grey--text text--darken-1 ml-2",
                    },
                    [
                      _vm._v(
                        " (automate_id: " +
                          _vm._s(
                            (_vm.changeStatusTarget &&
                              _vm.changeStatusTarget.automate_id) ||
                              "-"
                          ) +
                          ") "
                      ),
                    ]
                  ),
                ]),
                _c(
                  "p",
                  { staticClass: "mb-3" },
                  [
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("create_attribute.change_status.current_label")
                        ) + ":"
                      ),
                    ]),
                    _vm.changeStatusTarget
                      ? _c(
                          VChip,
                          {
                            staticClass: "ml-1",
                            attrs: {
                              "x-small": "",
                              "text-color": _vm.getStatus(
                                _vm.changeStatusTarget.estado
                              ).textColor,
                              color: _vm.getStatus(
                                _vm.changeStatusTarget.estado
                              ).color,
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getStatus(_vm.changeStatusTarget.estado)
                                    .text
                                ) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c(VSelect, {
                  attrs: {
                    items: _vm.changeStatusOptions,
                    "item-text": "text",
                    "item-value": "value",
                    label: _vm.$t("create_attribute.change_status.new_label"),
                    outlined: "",
                    dense: "",
                  },
                  model: {
                    value: _vm.changeStatusNewStatus,
                    callback: function ($$v) {
                      _vm.changeStatusNewStatus = $$v
                    },
                    expression: "changeStatusNewStatus",
                  },
                }),
                _c(VTextarea, {
                  attrs: {
                    label: _vm.$t(
                      "create_attribute.change_status.reason_label"
                    ),
                    hint: _vm.$t("create_attribute.change_status.reason_hint"),
                    rules: _vm.changeStatusReasonRules,
                    counter: "500",
                    maxlength: "500",
                    rows: "3",
                    outlined: "",
                    dense: "",
                    "persistent-hint": "",
                  },
                  model: {
                    value: _vm.changeStatusReason,
                    callback: function ($$v) {
                      _vm.changeStatusReason = $$v
                    },
                    expression: "changeStatusReason",
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsRight",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    attrs: {
                      color: "primary",
                      disabled:
                        !_vm.canConfirmChangeStatus || _vm.changeStatusSending,
                      loading: _vm.changeStatusSending,
                    },
                    on: { click: _vm.confirmChangeStatus },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("create_attribute.change_status.confirm_btn")
                        ) +
                        " "
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialogs-component", {
        ref: _vm.DIALOG_SENT_TO_REVIEW,
        attrs: {
          title: _vm.$t("create_attribute.review.sent_title"),
          "show-buttons": true,
          "show-cancel-button": false,
          width: 800,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  VAlert,
                  {
                    staticClass: "mb-4",
                    attrs: { type: "info", outlined: "", dense: "" },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("create_attribute.review.sent_message")) +
                        " "
                    ),
                  ]
                ),
                _vm.sentReviewValidation &&
                Array.isArray(_vm.sentReviewValidation.errors) &&
                _vm.sentReviewValidation.errors.length
                  ? _c("partition-validation-errors", {
                      attrs: { validation: _vm.sentReviewValidation },
                    })
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsRight",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    attrs: { color: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.onCloseDialog(_vm.DIALOG_SENT_TO_REVIEW)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("btns.close")) + " ")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }